// extracted by mini-css-extract-plugin
export default {"progressNoteSectionRow":"ProgressNoteSection_progressNoteSectionRow__m8IBo","textArea":"ProgressNoteSection_textArea__UUSah"};